import {http, onSuccess, onFail, formDataBuilder} from './http';

export const createPdfScheduleSettings = (eventKey) => {
    return http.post(`/api/cp/event/${eventKey}/pdf/settings/schedule`)
        .then(onSuccess, onFail);
};

export const getPdfScheduleSettings = (eventKey) => {
    return http.get(`/api/cp/event/${eventKey}/pdf/settings/schedule`)
        .then(onSuccess, onFail);
};

export const updatePdfScheduleSettings = (settingsId, payload) => {
    const formData = formDataBuilder(payload);

    return http.post(`/api/cp/event/pdf/settings/schedule/${settingsId}`, formData)
        .then(onSuccess, onFail);
};
